import CoordinateUtil from "utils/CoordinateUtil.js";

export interface SpeedFilterOptions {
  maxAcceleration?: number;
  lookbackPoints?: number;
}

export const interpolateAndFilterSpeedFromPoints = (points: any[], options: SpeedFilterOptions = {}): any[] => {
  const {maxAcceleration = 3, lookbackPoints = 4} = options;

  if (!points || points.length === 0) {
    return points;
  }

  const processedPoints: any[] = [];
  let totalDistance = 0.0;
  let totalDuration = 0.0;

  return points.map((point, index) => {
    let speed = point.speed ?? point.s ?? -1;

    let distance = 0.0;
    let duration = 1.0;
    let previousDistance = 0.0;
    let previousDuration = 1.0;

    // calculate distance and duration from lookback point for better speed calculation
    if (index > lookbackPoints && processedPoints.length >= lookbackPoints) {
      const lookbackPoint = processedPoints[processedPoints.length - lookbackPoints];
      previousDistance = CoordinateUtil.calculateDistanceBetweenCoordinateInMeter(
        {latitude: lookbackPoint.latitude, longitude: lookbackPoint.longitude},
        {latitude: point.latitude, longitude: point.longitude}
      );
      previousDuration = point.timestamp - lookbackPoint.timestamp;
    }

    // calculate distance and duration from previous point
    if (index > 0 && processedPoints.length > 0) {
      const previousPoint = processedPoints[processedPoints.length - 1];
      distance = CoordinateUtil.calculateDistanceBetweenCoordinateInMeter(
        {latitude: previousPoint.latitude, longitude: previousPoint.longitude},
        {latitude: point.latitude, longitude: point.longitude}
      );
      duration = point.timestamp - previousPoint.timestamp;
      totalDistance = totalDistance + distance;
      totalDuration = totalDuration + duration;
    }

    // calculate speed if not available
    if (speed === -1) {
      if (previousDuration > 0) {
        speed = previousDistance / previousDuration;

        // filter unrealistic speed changes
        if (processedPoints.length > 0) {
          const previousSpeed = processedPoints[processedPoints.length - 1].calculatedSpeed ?? 0;
          const acceleration = (speed - previousSpeed) / duration;

          if (acceleration > maxAcceleration) {
            speed = 0;
          }
        }
      } else {
        speed = 0;
      }
    }

    if (isNaN(speed) || speed < 0 || speed === Infinity) {
      speed = 0;
    }

    const processedPoint = {
      ...point,
      latitude: point.latitude,
      longitude: point.longitude,
      timestamp: point.timestamp,
      calculatedSpeed: speed
    };

    processedPoints.push(processedPoint);

    return {
      ...point,
      speed: speed,
      s: speed // Also set the 's' property for compatibility
    };
  });
};
